import type { U2000TableColumn } from '../../basic/U2000BasicTableList';

export type U2000StringCriteriaEditorMode = 'in' | 'interval' | 'none' | 'fallback';

export function isStringInOperator(conditionName: string | undefined): boolean {
  return conditionName === 'in';
}

/** Colonne string texte libre (sans lookup ni liste fermée). */
export function isFreeTextStringColumn(field: U2000TableColumn | null): boolean {
  if (!field || field.type !== 'string') return false;
  if (field.criteriaLookup != null) return false;
  if (field.criteriaInitOptions != null) return false;
  if ((field.criteriaStaticOptions?.length ?? 0) > 0) return false;
  return true;
}

/** True si l'éditeur Parmi doit utiliser U2000CriteriaFreeTextTagsInput (BL-0059, global CriteriaLine). */
export function isStringCriteriaFreeTextInTagsMode(
  field: U2000TableColumn | null,
  conditionName: string | undefined,
): boolean {
  return resolveStringCriteriaEditorMode(field, conditionName) === 'in';
}

/** Détermine le mode d'éditeur pour une colonne string sans lookup (tags uniquement pour `in`). */
export function resolveStringCriteriaEditorMode(
  field: U2000TableColumn | null,
  conditionName: string | undefined,
): U2000StringCriteriaEditorMode {
  if (!isFreeTextStringColumn(field)) return 'fallback';
  if (isStringInOperator(conditionName)) return 'in';
  if (conditionName === 'interval') return 'interval';
  if (conditionName === 'isNull' || conditionName === 'isNotNull') return 'none';
  return 'fallback';
}
